"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var MainContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  will-change: transform;\n  user-select: none;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 100%;\n  will-change: transform;\n  user-select: none;\n  position: relative;\n"])));
function CarouselSlide(props) {
    return react_1.default.createElement(MainContainer, { style: props.style }, props.children);
}
exports.default = CarouselSlide;
var templateObject_1;
//# sourceMappingURL=index.js.map